import { REQUISITION_STATUSES } from '../constants'

export default status => {
  switch (status) {
    case REQUISITION_STATUSES.PRE_REQUISITION:
    case REQUISITION_STATUSES.CREATED:
      return 'Pending Approval'
    case REQUISITION_STATUSES.REQUISITION_APPROVED:
    case REQUISITION_STATUSES.TEST_RESULTS_APPROVED:
      return 'Approved'
    case REQUISITION_STATUSES.TEST_RESULTS_RECEIVED:
      return 'New'
    default:
      return status
  }
}
